import { ns } from '../global/namespace.js';

export const GROUP_ATTR = ns.attr('group');
